import { createContext } from "react";

// Standalone pages provide a footer only when the route shell does not.
export const SiteFooterContext = createContext(false);
